<div class="measure-card" *ngIf="viewModel$ | async as vm" (click)="selectMeasureCard(vm.selected)">
  <section class="is-flex gap-8 bg-grey-10 bg-blue-hover-5" [class.selected]="vm.selected">
    <app-icon [name]="measureCard.icon" class="text-24"></app-icon>
    <app-text class="text-12 is-family-semiBold">{{ (measureCard.sidebarLabel ?? measureCard.label) | AsyncLang | async }}</app-text>
  </section>
</div>